import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getUrl } from "../../api";
import useMedia from "../../hooks/useMedia";
import usePermission from "../../hooks/usePermission";
import mocData from "./mocData";
import SimilarCardsList from "./SimilarCardsList";
import DetailHeader from "../Public/markup/detail/DetailHeader";
import InfoCard from "../Public/markup/detail/InfoCard";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Slider from "../Public/markup/detail/Slider";
import ContactCard from "../core/ContactCard";
import SubmitButton from "../SubmitButton";
import { useModal } from "react-modal-hook";
import PanModal from "../core/PanModal";
import FixateClient from "../../pages/FixateClientSpecial";
import RecordViewing from "../RecordViewing";
import RecordViewingSuburban from "../RecordViewing/suburban";
import RecordClient from "../RecordViewing/suburban2";
import useApi from "../../hooks/useApi";
import { successToast } from "../toasts";
import { downloadLink, objectsArrayToFormData, toFormData } from "../../utils";
import useModalWithData from "../../hooks/useModalWithData";
import CompilationModal from "../../pages/NewFavorites/compilationModal";
import {
  AddToCompilationIcon, ChatBackArrowIcon,
  ComissionIcon,
  FixIcon,
  HeartIcon,
  PdfIcon,
  SuburbanAboutMainIcon,
  SuburbanBedIcon,
  SuburbanBuildingAreaIcon,
  SuburbanCeilingHeightIcon,
  SuburbanCountBathroomsIcon,
  SuburbanProjFloorIcon,
  SuburbanProjMetrIcon,
  SuburbanProjSecondFasadIcon,
  SuburbanProjSecondFloorIcon,
  SuburbanProjSecondHouseIcon,
  SuburbanProjSecondRepairIcon,
  SuburbanProjSecondRoofIcon,
  ViewIcon
} from "../Public/markup/icons";
import AddPresenatation from "../AddPresentation";
import AppPopover from "../core/Popover";
import Wrap from "../core/ModalWrap";
import MobileModal from "../core/MobileModal";
import Modal from "../core/Modal";
import SpecialForm from "../forms/Special";
import ViewApartment from "../forms/ViewApartment";
import Header from "../Public/markup/Header";


const data = mocData;
const photos = { ...data.block.photos }
const photosComplex = {
  complex: [...(photos.complex ? photos.complex : [])],
  ...(!!data.block.aeroPanorama ? { aeroPanorama: data.block.aeroPanorama } : [])
}
const DetailCardNew = props => {
  const isMobile = useMedia("isMobile");
  const {
    presentation,
    heightCell1,
    decoration,
    features,
    manager,
    floors,
    openSpecialModal,
    countBedrooms,
    heightCell2,
    commission,
    id,
    title,
    price,
    squareTotal,
    meterPrice,
    section,
    squareHouse,
    constructionPeriod,
    photos,
    planPhotos,
    decorationPhotos,
    livingWinter,
    semiObjects,
    hidePrice,
    objectInfo,
    priceInfo,
    dateUpdateInfo,
    detailText,
    inFavorite,
    toggleFavorite,
    otherProjects,
    equipments,
    savedFilterSettings,
    projectInfo,
    savedFilterXmlId
  } = props
  const photosObject = {
    complex: photos,
    plan: planPhotos
  }
  const isTablet = useMedia('isTablet');
  const isDesktop = useMedia("isDesktop");
  const [numberOfSlides, setNumberOfSlides] = useState(0);
  const handleInit = (swiper) => {
    if (swiper) {
      setNumberOfSlides(swiper.slides.length);
    }
  };

  const [complexView, setComplexView] = useState('photos')

  const shoowMotivation = usePermission("motivation")


  const [openFixModal, closeFixModal] = useModal(
    () => (
      <PanModal title={'Фиксация клиента'} closeModal={closeFixModal} isBig>
        <FixateClient redesign closeFixModal={closeFixModal} objectId={id} />
      </PanModal>
    ),
    [],
  );

  const [bookATourModal, closeBookATourModal] = useModal(
    () => (
      <PanModal title={'Запись на просмотр по проектам домов'} closeModal={closeBookATourModal} isBig>
        {/*<RecordViewingSuburban/>*/}
        <RecordClient redesign objectId={id} close={closeBookATourModal} />
      </PanModal>
    ),
    [],
  );


  const [specSpecModal, closeSpecModal] = useModal(
    () => (
      <Wrap wrapper={children => isMobile
        ? <MobileModal closeClick={closeSpecModal} title="Запись на просмотр">{children}</MobileModal>
        : <Modal close={closeSpecModal} classes="modal_task">{children}</Modal>
      } >
        <SpecialForm close={() => {
          closeSpecModal()
        }}
          specialOfferId={id}
        // isShowRoom={isShowRoom} setIsShowRoom={setIsShowRoom}
        />
      </Wrap >
    ));

  const {
    openModal: openCompilationModal,
  } = useModalWithData({
    component: ({ closeModal, favorite }) => <CompilationModal
      close={closeModal}
      addToCompilationParams={[{ objectId: id, city: 'spb', type: 'project' }]}
    />,
    modalProps: {
      withoutBG: true,
      closeByPastClick: true,
      classes: "crm-table__sf-controlsmodal crm-table__sf-controlsmodal_compilation",
    },
    dep: []
  })



  return (
    <>
      <div className="subuebans-object">

        {!savedFilterSettings?.hideHeader && (
          <Header {...manager} savedFilterSettings={savedFilterSettings} />
        )}

        <div className="sf__detail-head" style={{marginBottom: 20}}>

          <h1 className="h3 sf__h1" style={{display: 'flex'}}>
            {/*<Link to={'/public/project/' + savedFilterXmlId} style={{marginTop: -4, display: 'flex', width: 35, height: 35, alignItems: 'center', justifyContent: 'center', marginRight: 10, cursor: 'pointer', background: '#f1f1f1', borderRadius: '50%'}}><ChatBackArrowIcon /></Link>*/}
            <span>{title}</span>
          </h1>

        </div>


        <div className="sf__detail-row">
          <div className="sf__detail-col complex-custom-view">

            {!isTablet && !!photos?.length && complexView == 'photos' && (
              <div className="complex-custom-view__main-container">
                <Slider
                  items={photos}
                  defoultThumbs
                />
              </div>
            )}

            {!isTablet && !!planPhotos?.length && complexView == 'planPhotos' && (
              <div className="complex-custom-view__main-container complex-custom-view__main-container_genplan">
                <Slider
                  items={planPhotos}
                  defoultThumbs
                />
              </div>
            )}


            <ul className="complex-view-list">
              <Swiper
                spaceBetween={15}
                slidesPerView={5}
                modules={[Navigation]}
                onInit={handleInit}
              >
                <SwiperSlide>
                  <li className={`complex-view-list__item ${complexView == 'photos' ? 'active' : ''}`} onClick={() => { setComplexView('photos') }}>
                    <img src={getUrl(photos?.[0].src)} alt="" />
                    <span>Фотографии</span>
                  </li>
                </SwiperSlide>
                {!!planPhotos && <SwiperSlide>
                  <li className={`complex-view-list__item ${complexView == 'planPhotos' ? 'active' : ''}`} onClick={() => { setComplexView('planPhotos') }}>
                    <img src={getUrl(planPhotos?.[0].src)} alt="" />
                    <span>Планировки</span>
                  </li> </SwiperSlide>}

              </Swiper>
            </ul>


            <div style={{marginTop: 30}} className="about-redesign">
              <div className="about-redesign__top">
                <div className="about-redesign__top-icon">
                  <SuburbanAboutMainIcon/>
                </div>

                <div className="about-redesign__top-content">
                  <p className="about-redesign__top-title">
                    О проекте
                  </p>

                  {
                    detailText && detailText !== '' &&
                    <p className="about-redesign__top-text" dangerouslySetInnerHTML={{ __html: detailText}}></p>
                  }

                  <div className="communications-redesign__list">
                    <ul className="about-redesign__list">

                      {projectInfo.map((i) => {
                        return (
                          <li className="about-redesign__list-item">
                            <div className="about-redesign__list-icon">

                              {i.type === 'squareHouse' && <SuburbanProjMetrIcon/>}
                              {i.type === 'countFloors' && <SuburbanProjFloorIcon/>}
                              {i.type === 'countBedrooms' && <SuburbanBedIcon/>}
                              {i.type === 'buildingArea' && <SuburbanBuildingAreaIcon/>}
                              {i.type === 'countBathrooms' && <SuburbanCountBathroomsIcon/>}
                              {i.type === 'ceilingHeight' && <SuburbanCeilingHeightIcon/>}

                            </div>
                            <div className="about-redesign__list-text">
                              <div className="about-redesign__listtext-sm">{i.title}</div>
                              <div className="about-redesign__listtext-bd">{i.value}</div>
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>

              </div>

            </div>


            {
              equipments?.length > 0 &&
              equipments.map((i) => {
                return (
                  <div style={{marginTop: 30}} className="about-redesign">
                    <div>
                      <p className="communications-redesign__title">{i.title}</p>

                      <div className="communications-redesign__list communications-redesign__list_white">
                        <ul className="about-redesign__list">

                          {i.items.map((it) => {
                            return (
                              <li className="about-redesign__list-item">
                                <div className="about-redesign__list-icon">

                                  {it.type === 'materialHouse' && <SuburbanProjSecondHouseIcon/>}
                                  {it.type === 'materialRoof' && <SuburbanProjSecondRoofIcon/>}
                                  {it.type === 'foundation' && <SuburbanProjSecondFloorIcon/>}
                                  {it.type === 'decorationHouse' && <SuburbanProjSecondRepairIcon/>}
                                  {it.type === 'facadeFinishing' && <SuburbanProjSecondFasadIcon/>}

                                </div>
                                <div className="about-redesign__list-text">
                                  <div className="about-redesign__listtext-sm">{it.title}</div>
                                  <div className="about-redesign__listtext-bd">{it.value}</div>
                                </div>
                              </li>
                            )
                          })}


                        </ul>
                      </div>


                      <div style={{marginTop: 20}}>
                        <p className="communications-redesign__title">Также в комплектацию входит:</p>
                        <ul className="about-redesign__complectation-list">
                          <div className="about-redesign__complectation-list-container" dangerouslySetInnerHTML={{ __html: i.description }}></div>
                          {/*<li>входные двери</li>*/}
                        </ul>
                      </div>

                      <div style={{display: "flex", justifyContent: 'flex-end'}}>
                        <span className="about-redesign__complectation-price">{i.price} </span>
                      </div>

                    </div>
                  </div>
                )
              })
            }


          </div>
          <div className="sf__detail-col">
            <InfoCard items={objectInfo} topDate={dateUpdateInfo.title + ' ' + dateUpdateInfo.value} cols={priceInfo} />

            <section className="sf__section">
              {presentation?.src &&
                <a
                  href={getUrl(presentation.src)}
                  type="application/octet-stream"
                  target="_blank"
                  // onClick={() => openSpecialModal(title, manager)}
                  className="button button_view_default btn h6 btn_primary btn_full "
                  download
                >
                  Скачать презентацию
                </a>
              }
            </section>



          </div>
        </div>

      </div>
    </>
  );
};

export default DetailCardNew;
